"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// biome-ignore lint/suspicious/noExplicitAny: Using any as a default for functions unless one is passed as a generic

const createContext = function () {
  const contextStack = [];
  return {
    inject: function (originalFunction) {
      return function () {
        const proxy = contextStack[contextStack.length - 1];
        if (proxy) return proxy(...arguments);
        return originalFunction(...arguments);
      };
    },
    provide: function (parentFunction, ctx) {
      return function () {
        contextStack.unshift(ctx);
        const result = parentFunction(...arguments);
        contextStack.shift();
        return result;
      };
    }
  };
};
var _default = exports.default = createContext;